import { render, staticRenderFns } from "./form-action.html?vue&type=template&id=2fb7ce54&scoped=true&"
import script from "./FormAction.vue?vue&type=script&lang=js&"
export * from "./FormAction.vue?vue&type=script&lang=js&"
import style0 from "./FormAction.vue?vue&type=style&index=0&id=2fb7ce54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb7ce54",
  null
  
)

export default component.exports